import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function PainPoints() {
  const negativePoints: React.ReactNode[] = ['El sueldo que tienes hoy no te permite llegar a fin de mes, el alquiler no para de subir y estás harta de hacer malabares con los números.', 'Quieres ganar dinero extra pero no puedes permitirte salir de casa ni perder el tiempo en cosas que no sirvan.', 'Ya probaste vender otras cosas — tartas, galletas, bizcochos — y terminaste agotada con poco margen y mucho trabajo.', 'Te frustra buscar recetas en internet y que nunca te salgan igual: se cortan, no cuajan, se van al traste los ingredientes.'];
  const positivePoints: React.ReactNode[] = ['Quieres un negocio simple, desde tu cocina, que funcione aunque empieces desde cero.'];
  return <section className="py-8 md:py-16 px-4 border-t border-cta-green bg-[#117932]" data-id="element-171">
      <div className="max-w-3xl mx-auto" data-id="element-172">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-center text-white mb-4 md:mb-10" data-id="element-173">
          Esto es para ti si…
        </h2>

        <div className="space-y-2 md:space-y-4" data-id="element-174">
          {negativePoints.map((point, index) => <div key={index} className="flex items-start bg-red-900/30 p-3 md:p-5 rounded-[10px] border-l-4 border-red-400" data-id="element-175">
              <XCircleIcon className="w-5 h-5 md:w-6 md:h-6 text-red-400 mt-0.5 mr-3 flex-shrink-0" data-id="element-176" />
              <p className="text-[15px] md:text-lg text-white font-medium leading-relaxed" data-id="element-177">
                {point}
              </p>
            </div>)}
        </div>

        <div className="mt-5 md:mt-10 space-y-2 md:space-y-4" data-id="element-178">
          {positivePoints.map((point, index) => <div key={index} className="flex items-start bg-green-400/20 p-3.5 md:p-6 rounded-[10px] border-l-4 border-green-300" data-id="element-179">
              <CheckCircle2Icon className="w-6 h-6 md:w-7 md:h-7 text-green-300 mt-0.5 mr-3 flex-shrink-0" data-id="element-180" />
              <p className="text-base md:text-xl text-white font-semibold leading-relaxed" data-id="element-181">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}